
<div class="contract_wrap">
  <div class="statistic-wrap gap-8 mb-8 flex sm:flex-col">
    <div *ngFor="let data of chartData;let i = index;"  class="statistic" [ngClass]="{ 'hover:bg-purpleBg': i==0, 'hover:bg-yellow100': i==1, 'hover:bg-green100': i==2}" [style.border-top]="'6px solid ' + data.color">
      <div>
        <p [style.color]="data.color" class="font14-w500">{{ data.label }} <i nz-icon nzType="exclamation-circle" nzTheme="outline" 
          nz-tooltip 
          [nzTooltipTitle]="data.tips" 
          class="ml-2 cursor-pointer">
       </i></p>
        <p style="display: flex; justify-content: center;"><span class="font-bold font18-w700">{{ formatMoney(data.value) }}</span>
        </p>
      </div>
    </div>
  </div>
  <div class="mb-4 flex justify-between items-center">
    <div class="flex justify-between items-center text-[16px]">
      <span>数据更新时间：{{latestUpdateTime}}</span>
      <div class="text-right ml-10">数据截至上一个工作日，仅供参考，请以线下结算为准。</div>
    </div>
    <div class="flex">
      <span style="font-size: 16px; display: flex; align-items: center; margin-right: 20px;">单位：元</span>
      <nz-select [(ngModel)]="selectedYear" class="w-[150px] bosch-select" 
      (ngModelChange)="onYearChange($event)">
      <nz-option *ngFor="let year of yearList" [nzValue]="year" [nzLabel]="year + '年'"> </nz-option>
  </nz-select>
    </div>

  </div>
  <div class="flex flex-col gap-[80px]" >
    <app-data-table
    tableTitle="ANNUAL_CONTRACT_TARGET_COMPLETION"
    [showDownload]="true"
    [pagination]="false"
    [data]="annualData"
    [total]="annualPagination.total"
    [pageNum]="annualPagination.pageNum"
    [pageSize]="annualPagination.pageSize"
    [columns]="annualColumns"
    (pageChange)="loadAnnuals($event)"
    (download)="exportAnnuals()"
  ></app-data-table>

  <app-data-table
    tableTitle="ANNUAL_CONTRACT_QUARTERLY_TARGET_COMPLETION"
    [showDownload]="true"
    [pagination]="false"
    [data]="quarterlyData"
    [total]="quarterlyPagination.total"
    [pageNum]="quarterlyPagination.pageNum"
    [pageSize]="quarterlyPagination.pageSize"
    [columns]="quarterlyColumns"
    (pageChange)="loadQuarterlys($event)"
    (download)="exportQuarterlys()"
  ></app-data-table>
  <app-data-table
  tableTitle="PRODUCT_LINE_ANNUAL_CONTRACT_TARGET_COMPLETION"
    [showDownload]="true"
    [pagination]="false"
    [data]="productData"
    [total]="productPagination.total"
    [pageNum]="productPagination.pageNum"
    [pageSize]="productPagination.pageSize"
    [columns]="productColumns"
    (pageChange)="loadProducts($event)"
    (download)="exportProducts()"
  ></app-data-table>
  <app-data-table
  tableTitle="ADDITIONAL_REBATE_AGREEMENT_TARGET_COMPLETION"
  *ngIf="extraRebateData.length>0"
    [showDownload]="true"
    [data]="extraRebateData"
    [total]="extraRebatePagination.total"
    [pageNum]="extraRebatePagination.pageNum"
    [pageSize]="extraRebatePagination.pageSize"
    [columns]="extraRebateColumns"
    (pageChange)="loadExtraData($event)"
    (download)="exportExtraData()"
  ></app-data-table>
  <app-data-table
  tableTitle="MARKET_REBATE_AGREEMENT_TARGET_COMPLETION"
  *ngIf="marketRebateData.length>0"
    [showDownload]="true"
    [data]="marketRebateData"
    [total]="marketPagination.total"
    [pageNum]="marketPagination.pageNum"
    [pageSize]="marketPagination.pageSize"
    [columns]="marketColumns"
    (pageChange)="loadMarketData($event)"
    (download)="exportMarketData()"
  ></app-data-table>
  <ng-template #progressTpl let-value>
    <div class="progress-wrapper">
      <nz-progress
      [nzPercent]="Math.round(value * 100)"
      class="custom-progress"
      [nzStrokeColor]="value*100 >= 90 ? '#9E2896' : '#007BC0'"
      [nzShowInfo]="true" nzStatus="normal">
    </nz-progress>
    <!-- <span class="absolute inset-0 flex items-center justify-center text-white text-[10px] font-medium mt-1 text-[#000]">
      {{ formatPercent(value) }}
    </span> -->
    </div>

  </ng-template>
  <ng-template #remainingAmountTpl let-value let-row="row">
    <span [ngStyle]="{
      'font-weight': 'bold',
      'color': getColorByValue(row.completionRate)
    }">
      {{ value}}
    </span>
  </ng-template>
  <ng-template #ratioTpl let-value let-row="row">
    <span>
      {{ value==='--'?value:(value * 100).toFixed(0)+'%'}}
    </span>
  </ng-template>
  </div>
   
</div>



